import { FreeSpinsCounterLandscapeProperties } from "../landscape/FreeSpinsCounterLandscapeProperties";
export class FreeSpinsCounterPortraitProperties extends FreeSpinsCounterLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.animation.position.set(512, 1716);
    }
}
